// Helper to determine the interval between data points based on amount of items in list of data
export const determineInterval = (lengthOfData: number): number => {
  if (!lengthOfData) {
    return 0;
  }

  if (lengthOfData <= 10) {
    return 0;
  } else {
    let interval = 1;
    let arrayLength = lengthOfData;

    while (arrayLength > 10) {
      interval++;
      arrayLength = arrayLength / interval;
    }

    return interval;
  }
};